import type { ScenarioProvenance } from '../domain/types';
export function ScenarioMemberStatus({
  provenance,
  compact = false,
}: {
  readonly provenance: ScenarioProvenance;
  readonly compact?: boolean;
}) {
  if (compact)
    return (
      <section className="scc-members">
        <h2>成员与组成状态</h2>
        <ul className="scc-member-summary">
          <li>ScenarioTemplate · FORMED MEMBER · VERSION CANDIDATE</li>
          <li>MissionTemplate · FORMED MEMBER · VERSION CANDIDATE</li>
          <li>LocalScenarioProfile · HOLD-AS-EXPLICIT-UNKNOWN · 无已核实本地 mandate</li>
          <li>Manifest · FORMED MEMBER · VERSION CANDIDATE</li>
          <li>Closure · NOT VERIFIED</li>
          <li>Composition · NOT FORMED · Package Identity NONE</li>
        </ul>
        <p>FORMED MEMBER ≠ PUBLISHED ≠ PACKAGE READY ≠ RUNNING</p>
      </section>
    );
  return (
    <section className="scc-members">
      <h2>成员与组成状态</h2>
      <dl className="scc-fields">
        <div>
          <dt>ScenarioTemplate</dt>
          <dd>
            FORMED_ARTIFACT_CONFIRMED · VERSION CANDIDATE · Git {provenance.frozenCommit}
            <br />
            SOURCE_BOUND_SYNTHETIC_FIXTURE · ST Backend 浏览器支持 NOT VERIFIED
          </dd>
        </div>
        <div>
          <dt>MissionTemplate</dt>
          <dd>
            FORMED MEMBER · VERSION CANDIDATE · Git {provenance.frozenCommit}
            <br />
            既有 MT Consumer 可显式开发读取；本页成功只证明单对象读取，不证明绑定。
          </dd>
        </div>
        <div>
          <dt>LocalScenarioProfile</dt>
          <dd>HOLD—NO VERIFIED LOCAL MANDATE · HOLD-AS-EXPLICIT-UNKNOWN</dd>
        </div>
        <div>
          <dt>ScenarioContentManifest</dt>
          <dd>
            FORMED MEMBER · VERSION CANDIDATE
            <br />
            {provenance.manifestPin.id} / {provenance.manifestPin.version}
            <br />
            形成记录 {provenance.manifestRecord}
          </dd>
        </div>
        <div>
          <dt>Closure</dt>
          <dd>NOT VERIFIED</dd>
        </div>
        <div>
          <dt>Composition</dt>
          <dd>NOT FORMED · Package Identity NONE</dd>
        </div>
      </dl>
      <p>FORMED MEMBER ≠ PUBLISHED ≠ PACKAGE READY ≠ RUNNING</p>
    </section>
  );
}
